export const environment = {
    production: true,
    apiUrl: 'https://api.cncdental.eu',
    uploaderUrl: 'https://api.cncdental.eu/archivos',
    mercureHub: 'https://api.cncdental.eu/hub/.well-known/mercure',
    // apiUrl: 'https://cnc-api.nedaware.eu',
    // uploaderUrl: 'https://cnc-api.nedaware.eu/archivos',
    // mercureHub: 'https://cnc-api.nedaware.eu/hub/.well-known/mercure',
    validez: 5,
    version: 'v2.2'
};
